import React, { HTMLProps } from "react";

export const ImageFileInput = React.forwardRef(function ImageFileInputImpl(
  props: Omit<HTMLProps<HTMLInputElement>, "hidden" | "type" | "accept"> & {
    accept?: string;
  },
  ref?: React.Ref<HTMLInputElement>
) {
  const { accept, ...rest } = props;
  return (
    <input
      hidden
      type="file"
      accept={accept ? accept : "image/png, image/jpeg"}
      ref={ref}
      {...rest}
    />
  );
});
